import { render, staticRenderFns } from "./ApplicationDetailsForm.vue?vue&type=template&id=f5594c9c&"
import script from "./ApplicationDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDetailsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApplicationDetailsForm.vue"
export default component.exports